import { useMediaQuery, useTheme } from "@mui/material";

export const useBreakpoint = () => {
  const theme = useTheme();
  return {
    isMobile: useMediaQuery(theme.breakpoints.down(640)), // <= 639px
    isTablet: useMediaQuery(theme.breakpoints.between(640, 784)), // 640px - 783px
    isLaptop: useMediaQuery(theme.breakpoints.between(784, 1024)), // 784px - 1023px
    isDesktop: useMediaQuery(theme.breakpoints.up(1024)), // >= 1024px
  };
};
